import React, { useState, useEffect, useContext } from "react";
import { Bell, Save } from "lucide-react";
import VendorLayout from "../../layout/HotelVendorLayout/VendorLayout";
import axios from "axios";
import AppContext from "../../context/AppContext";
import Swal from "sweetalert2";
import "../../assets/css/vendors/HotelScreens/hotelNotificationSetting.css";

const HotelNotificationSettings = () => {
const { baseUrl, authToken } = useContext(AppContext);
const [notifications, setNotifications] = useState({
    inAppNotifications: false,
    emailNotifications: false,
  });

  useEffect(() => {
    axios
      .get(`${baseUrl}/vendor/get`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success && response.data.data) {
          const vendor = response.data.data;
          setNotifications((prev) => ({
            ...prev,
            inAppNotifications: !!Number(vendor.in_app_notifications),
          }));
        } else {
          console.log("Vendor not found or fetch failed:", response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [baseUrl, authToken]);

  const handleSave = () => {
    axios.post(
      `${baseUrl}/vendor/notification-settings`,
      {
        in_app_notifications: notifications.inAppNotifications ? 1 : 0
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
    .then((response) => {
      Swal.fire("Success", response.data.message, "success");
    })
    .catch((error) => {
      console.log(error);
      Swal.fire("Error", "Failed to save notification settings", "error");
    });
  };

  return (
    <VendorLayout>
      <div className="ven-notif-container">
        <div className="ven-notif-wrapper">
          <div className="ven-notif-page-header">
            <Bell size={28} className="ven-notif-header-icon" />
            <h2 className="ven-notif-page-title">Notification Settings</h2>
          </div>

          <div className="ven-notif-settings-card">

            <div className="ven-notif-card-header">
              <Bell size={24} className="ven-notif-card-icon" />
              <h4 className="ven-notif-card-title">Manage Your Notifications</h4>
            </div>

            <div className="ven-notif-section">
              <h6 className="ven-notif-section-title">
                In-app Notifications
              </h6>
              <p className="ven-notif-section-description">
                Receive notifications within the app about bookings, orders, and updates
              </p>

              <div className="ven-notif-toggle-item">
                <div className="ven-notif-toggle-info">
                  <span className="ven-notif-toggle-label">
                    Enable In-app Notifications
                  </span>
                  <span className="ven-notif-toggle-description">
                    Get instant notifications about your bookings, room orders, and important updates while using the app
                  </span>
                </div>

                <div
                  className={`ven-notif-toggle-switch ${
                    notifications.inAppNotifications
                      ? "ven-notif-active"
                      : ""
                  }`}
                  onClick={() =>
                    setNotifications((prev) => ({
                      ...prev,
                      inAppNotifications: !prev.inAppNotifications,
                    }))
                  }
                >
                  <div className="ven-notif-toggle-slider" />
                </div>
              </div>
            </div>

            <button
              className="ven-notif-save-button"
              onClick={handleSave}
            >
              <Save size={18} />
              Save Preferences
            </button>

          </div>
        </div>
      </div>
    </VendorLayout>
  );
};

export default HotelNotificationSettings;